import s from './Tooltip.module.css'
import { ReactNode, FC } from 'react'

interface Props {
  title?: string
  message?: string
  closeIcon?: any
  image?: any
  children?: ReactNode
  activeHover?: boolean
  className?: string
  link?: any
}

const Tooltip: FC<Props> = ({
  title,
  message,
  closeIcon,
  image,
  children,
  activeHover,
  className,
  link,
}) => {
  return (
    <div className="relative top-1.5 flex flex-col items-center group">
      {children}
      {activeHover === true ? (
        /*checkboxes*/
        <div className="absolute -bottom-4 flex flex-col items-center z-50 ">
          <span className={`${s.span} ${className} relative`}>
            <span className="top-1 right-1 absolute cursor-pointer">
              {closeIcon}
            </span>

            <h3 className={s.titleCheckbox}>
              {title} <span className="align-sub">{image}</span>
            </h3>
            <p className="mb-4">
              {message}
              {link}
            </p>
          </span>
          <div className="w-3 h-3 rotate-45 bg-white border-2 border-solid border-[#5c8494] border-b-0 border-r-0"></div>
        </div>
      ) : (
        /*tab*/
        <div className=" bottom-0.5 flex flex-col items-center z-[1] md:z-30">
          <span className={`${s.span} ${className} relative`}>
            <span className="top-1 right-1 absolute cursor-pointer">
              {closeIcon}
            </span>

            <div>
              <h3 className={s.titleTab}>
                {title}
                <span className="md:absolute -top-3">{image}</span>
              </h3>
            </div>
            <div className="mb-4">
              {message}
              <p className="text-accent-9 underline inline">{link}</p>
            </div>
          </span>
          <div className="w-3 h-3 rotate-45 bg-white border-2 border-solid border-[#5c8494] border-b-0 border-r-0"></div>
        </div>
      )}
    </div>
  )
}

export default Tooltip
